/** The guide is optional help. Its state never changes form values, Save or readiness. */
import type { ReactNode } from 'react'
import type {
  StudyBuilderEvaluationGuidance as Guidance,
  ShopifyStudyBuilderEvaluationResponse,
} from '@testfeed/shopify-contracts'
import { shopifyComponentCopy } from '@testfeed/product-language'
import { useStudyBuilderGuidance } from '../../hooks/outside/useStudyBuilderGuidance'
import type { StudyBuilderLifecycle } from '../../hooks/study-builder/studyBuilderLifecycle'
import { ActionButton } from '../ActionButton'

export function StudyBuilderGuidance({
  guide,
  sections,
  lifecycle,
  children,
}: {
  guide: Guidance | null
  sections: ShopifyStudyBuilderEvaluationResponse['sections']
  lifecycle: StudyBuilderLifecycle
  children: ReactNode
}) {
  const { root, open } = useStudyBuilderGuidance(guide, sections)
  // The tour is offered from the page's "…" menu whenever the Worker says it can run (`guide.available`). It starts by
  // itself the first time (the hook reads `guide.autoStart`); the menu entry replays it afterwards. No button on the form.
  const available = guide?.available ?? false
  return (
    <>
      {available && (
        <ActionButton
          slot="secondary-actions"
          lifecycle={lifecycle}
          action="open-guidance"
          onClick={() => lifecycle.run('open-guidance', open)}
        >
          {shopifyComponentCopy.studyBuilderGuidance.start}
        </ActionButton>
      )}
      <div ref={root}>{children}</div>
    </>
  )
}
